<template>
  <div class="auth-btn">
    <el-button plain
               v-for="(btn,index) in btns"
               :key="btn.key"
               :title="btn.tip"
               @click="checkBtn(btn,index)"
               :class="{'active':index<=hoverIndex||index<=selectedIndex}"
               @mouseenter.native="mouseenter(btn,index)"
               @mouseleave.native="mouseleave(btn,index)">{{btn.label}}
    </el-button>
  </div>
</template>

<script>
  import {Category} from "@digital-supply-chain/module";

  export default {
    name: "auth-btn",
    props: {
      categoryId: {
        type: Number,
        default: 110
      },
      value: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        hoverIndex: 0,
        selectedIndex: 0
      }
    },
    computed: {
      btns() {
        switch (this.categoryId) {
          case Category.Drawing:
          case Category.Part:
          case Category.Document:
            return [{key: "view", label: "仅查看", value: 4, tip: "文档可在线预览"}, {
              key: "download",
              label: "可下载",
              value: 1
            }, {key: "edit", label: "可修改", value: 1}, {key: "del", label: "可管理", value: 1, tip: "可重命名、删除及授权"}];
          case Category.Enterprise:
          case Category.OutSource:
            return [{key: "view", label: "仅查看", value: 4}, {key: "edit", label: "可修改", value: 1}, {
              key: "del",
              label: "可管理",
              value: 1,
              tip: "可删除及授权"
            }];
          case  Category.DrawingDir:
          case  Category.DocumentDir:
          case  Category.EnterpriseDir:
          case  Category.EnterpriseShare:
          case  Category.LectoFavoriteDir:
          case  Category.OutSourceDir:
          case  Category.OutSourceDirShare:
            return [{key: "view", label: "仅查看", value: 4}, {key: "add", label: "可写入", value: 1}, {
              key: "del",
              label: "可管理",
              value: 1,
              tip: "可重命名、授权，删除文件夹内容"
            }];
          default :
            return [];

        }
      }
    },
    watch:{
      value(){
        this.init();
      }
    },
    methods: {
      checkBtn(btn, index) {
        const selectedBtn = this.btns.slice(0, index + 1);
        this.selectedIndex = index;
        const value = {};
        selectedBtn.forEach(item => {
          value[item.key] = item.value;
        });
        this.$emit("input", value);
      },
      mouseenter(btn, index) {
        this.hoverIndex = index;
      },
      mouseleave(btn, index) {
        this.hoverIndex = 0;
      },
      init() {
        this.btns.forEach((item, index) => {
          // >=的原因是view权限有可能是
          if (this.value[item.key] == item.value) this.selectedIndex = index;
        })
      }
    },
    mounted() {
      this.init();
    }
  }
</script>

<style scoped lang="less">
  .auth-btn {
    /deep/ .el-button {
      padding: 6px;
      font-size: 13px;
      border-radius: 0;
      &:first-of-type{
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
      }
      &:last-of-type{
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
      }

      + .el-button {
        margin-left: 0;
        border-left: 0;
      }
      &.active {
        background: #FFF;
        border-color: #409EFF;
        color: #409EFF;
      }
    }
  }
</style>